import { render, staticRenderFns } from "./MailingsCreateBatch.vue?vue&type=template&id=10360bdf&scoped=true&"
import script from "./MailingsCreateBatch.vue?vue&type=script&lang=ts&"
export * from "./MailingsCreateBatch.vue?vue&type=script&lang=ts&"
import style0 from "./MailingsCreateBatch.vue?vue&type=style&index=0&id=10360bdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10360bdf",
  null
  
)

export default component.exports